// extracted by mini-css-extract-plugin
export default {"tableCl":"CurrencyTable_tableCl__GK0yQ","negative":"CurrencyTable_negative__+Hans","positive":"CurrencyTable_positive__LrKK8","even":"CurrencyTable_even__Kayox"};